export default "__VITE_ASSET__BzcQcLjI__"